export const ADD_RESTAURANT = 'ADD_RESTAURANT'
export const ADD_RESTAURANTS = 'ADD_RESTAURANTS'
export const LOAD_RESTAURANT = 'LOAD_RESTAURANT'
export const RESTAURANT_MEALS = 'RESTAURANT_MEALS'